export default __webpack_public_path__ + "static/media/Img028.44c408f9.jpg";